import {
  Text,
} from '@chakra-ui/react';
import {
  useFreightAccessibility,
} from '@src/modules/performance/context/reports-api-hooks';
import { CHART_COLOURS } from '@src/modules/performance/shared/constants';
import DualBarChart from '@src/modules/performance/components/charts/DualBarChart';
import ReportSection from './ReportSection';

const informationSource = {
  title: 'Freight Access (ONRC)',
  content: [
    {
      title: 'Network accessible to heavy vehicles',
      description:
  <Text fontSize="inherit" mb={2}>
    This measure shows the proportion of each road classification that is accessible to Class 1 Heavy Vehicles and 50MAX Vehicles, summarised by ONRC Category. Reports &quot;No data to show&quot; for networks with no data either entered for the ONRC input measure in Transport Insights or calculated from the Road Closures and Restrictions item in AWM.
  </Text>,
      source:
  <Text fontSize="inherit" as="span">
    Sourced from Transport Insights / AWM.
  </Text>,
    },
  ],
};

function NetworkAvailabilityFreightAccessibilityDistributionOnrc() {
  const { data, isLoading } = useFreightAccessibility('onrc');

  const chartSeries = [
    {
      name: 'Class 1 HCV %',
      type: 'bar',
      data: data?.map((item) => ({
        x: item.ONRC,
        y: item.Class_1_HCV > 0 ? (100 - item.Class_1_HCV) : 100,
      })),
      color: CHART_COLOURS.blue,
    },
    {
      name: '50MAX %',
      type: 'bar',
      data: data?.map((item) => ({
        x: item.ONRC,
        y: item.fifty_Max > 0 ? (100 - item.fifty_Max) : 100,
      })),
      color: CHART_COLOURS.red,
    },
  ];

  return (
    <ReportSection
      title="Freight Access (ONRC)"
      isLoading={isLoading || !data}
      informationSource={informationSource}
      lockYear={data?.[0]?.LockYear || null}
    >
      <DualBarChart
        title="Network accessible to heavy vehicles"
        categories={[...new Set(data?.map((item) => item.ONRC))]}
        series={chartSeries}
        suffix="%"
        min={90}
        width="260"
      />
    </ReportSection>
  );
}

export default NetworkAvailabilityFreightAccessibilityDistributionOnrc;
